import { render, staticRenderFns } from "./ButtonToHalloween.vue?vue&type=template&id=012f69ce&scoped=true&"
import script from "./ButtonToHalloween.vue?vue&type=script&lang=js&"
export * from "./ButtonToHalloween.vue?vue&type=script&lang=js&"
import style0 from "./ButtonToHalloween.vue?vue&type=style&index=0&id=012f69ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f69ce",
  null
  
)

export default component.exports